/**
 * <plp-sticky-bar> — the PLP title row (sections/main-collection-product-grid.liquid).
 * CSS pins it under the header; this marks it `is-stuck` while pinned, so the
 * strip can slim down to the count and gender tabs.
 *
 * A zero-height marker sits just above the bar: once the marker scrolls under the
 * header, the bar is pinned. The marker doesn't move when the bar changes height,
 * so the strip slimming down can't flip the state back.
 */
class PlpStickyBar extends HTMLElement {
  connectedCallback() {
    this.marker = document.createElement('div');
    this.marker.setAttribute('aria-hidden', 'true');
    this.before(this.marker);

    this.scrollHandler = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    };
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
    window.addEventListener('resize', this.scrollHandler, { passive: true });
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.scrollHandler);
    window.removeEventListener('resize', this.scrollHandler);
    if (this.frame) cancelAnimationFrame(this.frame);
    this.marker?.remove();
  }

  update() {
    // Only while CSS actually pins it (desktop, with gender tabs).
    const stickyTop = getComputedStyle(this).position === 'sticky' ? parseFloat(getComputedStyle(this).top) : NaN;
    const isStuck = !Number.isNaN(stickyTop) && this.marker.getBoundingClientRect().top < stickyTop;
    this.classList.toggle('is-stuck', isStuck);
  }
}

if (!customElements.get('plp-sticky-bar')) {
  customElements.define('plp-sticky-bar', PlpStickyBar);
}
